var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.864,
    height: 39.423,
    viewBox: "0 0 93.864 39.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M274.362,731.513h3.754v26.282h-3.754Zm-63.828,5.631v15.021a5.63,5.63,0,0,1-5.63,5.63H184.252V718.372h3.755v13.141h16.9A5.631,5.631,0,0,1,210.534,737.144Zm-3.755-.005a1.872,1.872,0,0,0-1.871-1.871H189.87a1.863,1.863,0,0,0-1.863,1.863v15.032a1.877,1.877,0,0,0,1.877,1.877H204.9a1.877,1.877,0,0,0,1.877-1.877Zm35.669,0v20.658H221.8a5.632,5.632,0,0,1-5.632-5.633v-9.386h22.527v-5.635a1.874,1.874,0,0,0-1.874-1.874H216.166v-3.755h20.658A5.624,5.624,0,0,1,242.448,737.137Zm-3.755,9.394H219.92v5.626a1.883,1.883,0,0,0,1.883,1.883h16.89Zm9.386-9.392v20.655h3.755V737.147a1.88,1.88,0,0,1,1.88-1.88H268.73v-3.755H253.706A5.626,5.626,0,0,0,248.08,737.139Z",
    transform: "translate(-184.252 -718.372)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBari);
export default __webpack_public_path__ + "static/media/logo-bari.6971d533a361c1d4cd56423122588a48.svg";
export { ForwardRef as ReactComponent };